<template>
    <div class="modal fade" id="sideMenuModal" tabindex="-1" aria-hidden="true"
        style="height: 100% !important;z-index:10002;border-radius:0px !important">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content">
                <hr class="m-0" />
                <div class="modal-body ">
                    <div class="d-flex justify-content-between">
                        <button type="button" class="btn" data-bs-dismiss="modal" id="sideMenuModalCloseBTN" >
                            <i class="fa fa-close"></i>
                        </button>
                        <h2 class="text-end" style="color: red;font-size: 22px;font-family: Adera!important;">RADAP</h2>
                    </div>
                    <!-- پاپ اپ وقتی وارد نشده باشد -->

                    <ul class="list-group list-group-flush" v-if="signSideMenuFlag == false">
                        <li class="list-group-item">
                            <div class="d-flex justify-content-between" style="flex-direction: row-reverse;">
                                <div>
                                    <!-- <i class="fa fa-moon-o" role="button" @click="nightMode('moon')"></i>
                                    <i class="fa fa-sun-o" style="display: none;"></i> -->
                                </div>
                            </div>
                        </li>
                        <li class="list-group-item" @click="goFollow(1)">ثبت نام</li>
                        <li class="list-group-item" @click="goFollow(2)">ورود به حساب کاربری</li>
                        <li class="list-group-item">
                            <a class="text-dark" href="https://rubika.ir/joing/EAEJCEHD0SVQPYRXQEEFTIDFYKFXRBSX">
                            پشتیبانی آنلاین 
                            </a>
                        </li>
                        <li class="list-group-item" @click="goBenefitPage">کسب درآمد</li>
                    </ul>
                    <!-- پاپ اپ وقتی وارد شده باشد -->
                    <ul class="list-group list-group-flush" v-else>
                        <li class="list-group-item">
                            <div class="d-flex justify-content-between" style="flex-direction: row-reverse;">
                                <div>
                                    <i class="fa fa-moon-o" role="button"></i>
                                    <!-- <i class="fa fa-moon-o" @click="nightMode('moon')"></i>
                                    <i class="fa fa-sun-o" style="display: none;" @click="nightMode('sun')"></i> -->
                                </div>
                                <div v-if="signSideMenuFlag == true" @click="goFollow(3)">
                                    <i class="fa fa-user ml-1"></i>{{ name }}
                                </div>
                            </div>
                        </li>
                        <li class="list-group-item" @click="goFollow(3)">حساب کاربری</li>
                        <li class="list-group-item"> 
                            <a class="text-dark" href="https://rubika.ir/joing/EAEJCEHD0SVQPYRXQEEFTIDFYKFXRBSX">
                            پشتیبانی آنلاین 
                            </a>
                        </li>
                        <li class="list-group-item" @click="goBenefitPage">کسب درآمد</li>
                        <li class="list-group-item" @click="goAboutPage">درباره ما</li>
                        <li class="list-group-item" @click="goContactPage">تماس با ما</li>
                        <li class="list-group-item text-danger" @click="exitAccount">خروج از حساب کاربری</li>
                    </ul>

                    <div class="position-fixed bottom-0 right-0 w-100">
                        <div class="bg-danger text-center w-100 p-2">شبکه های اجتماعی</div>
                        <ul class="list-group d-flex justify-content-around w-100 right-0" style="flex-direction: row;">
                            <li class="list-group-item w-25 border-0 text-center ">
                                <a href="https://www.facebook.com/profile.php?id=100028684254376" class="facebook">
                                    <div> <i class="fa fa-facebook text-dark" style="font-size: 24px;"  aria-hidden="true"></i> </div>
                                </a>
                            </li>
                            <li class="list-group-item w-25 border-0 text-center ">
                                <a href="https://instagram.com/radap_ir?igshid=MGNiNDI5ZTU=" class="instagram">
                                    <div><i class="fa fa-instagram text-dark"  style="font-size: 24px;" aria-hidden="true"></i></div>
                                </a>
                            </li>
                            <li class="list-group-item w-25 border-0 text-center ">
                                <a href="https://chat.whatsapp.com/HnNm911wOSn4G7bVBhBx26" class="whatapp">
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                            <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
                                        </svg>
                                    </div>
                                </a>
                            </li>
                            <li class="list-group-item w-25 border-0 text-center ">
                                <a href="https://t.me/onlin_radap#" class="telegram">
                                    <div>
                                        <svg width="24px" height="24px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;"><path id="telegram-5" d="M12,0c-6.627,0 -12,5.373 -12,12c0,6.627 5.373,12 12,12c6.627,0 12,-5.373 12,-12c0,-6.627 -5.373,-12 -12,-12Zm0,2c5.514,0 10,4.486 10,10c0,5.514 -4.486,10 -10,10c-5.514,0 -10,-4.486 -10,-10c0,-5.514 4.486,-10 10,-10Zm2.692,14.889c0.161,0.115 0.368,0.143 0.553,0.073c0.185,-0.07 0.322,-0.228 0.362,-0.42c0.435,-2.042 1.489,-7.211 1.884,-9.068c0.03,-0.14 -0.019,-0.285 -0.129,-0.379c-0.11,-0.093 -0.263,-0.12 -0.399,-0.07c-2.096,0.776 -8.553,3.198 -11.192,4.175c-0.168,0.062 -0.277,0.223 -0.271,0.4c0.006,0.177 0.125,0.33 0.296,0.381c1.184,0.354 2.738,0.847 2.738,0.847c0,0 0.725,2.193 1.104,3.308c0.047,0.139 0.157,0.25 0.301,0.287c0.145,0.038 0.298,-0.001 0.406,-0.103c0.608,-0.574 1.548,-1.461 1.548,-1.461c0,0 1.786,1.309 2.799,2.03Zm-5.505,-4.338l0.84,2.769l0.186,-1.754c0,0 3.243,-2.925 5.092,-4.593c0.055,-0.048 0.062,-0.13 0.017,-0.188c-0.045,-0.057 -0.126,-0.071 -0.188,-0.032c-2.143,1.368 -5.947,3.798 -5.947,3.798Z" /> </svg>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { useRouter } from "vue-router";
import { ref } from '@vue/reactivity'
import { onMounted } from "vue";

let router = useRouter();
let signSideMenuFlag = ref(false)
let name = ref('')
// onMounted(() => {
//     document.querySelector('#sideMenuTempSign').style.visibility = 'hidden'
//     document.querySelector('#sideMenuTemp').style.visibility = 'hidden'
// })
validSignIn()
function validSignIn() {
    if (localStorage.getItem('userInfo') !== null) {
        signSideMenuFlag.value = true
        name.value = JSON.parse(localStorage.getItem('userInfo'))[0]['name'] + ' ' + JSON.parse(localStorage.getItem('userInfo'))[0]['family']
    }
}
function goBenefitPage() {
    document.getElementById('sideMenuModalCloseBTN').click()
    router.push({ name: 'Benefit' })
}
function goAboutPage() {
    document.getElementById('sideMenuModalCloseBTN').click()
    router.push({ name: 'About' })
}
function goContactPage() {
    document.getElementById('sideMenuModalCloseBTN').click()
    router.push({ name: 'Contact' })
}
function goFollow(type) {
    if (type == 1) {
        document.querySelector('#mobileModalBTN').click()
    } else if (type == 2) {
        document.querySelector('#loginsModalBTN').click()
    } else if (type == 3) {
        document.querySelector('#sideMenuModalCloseBTN').click()
        router.push({ name: 'Account',hash:'#profile' })

    }
}
function exitAccount() {
    localStorage.removeItem("userInfo");
    localStorage.removeItem("basket");
    window.location.href = 'https://radap.ir'
}
function nightMode(mode) {

    //   var element = document.body;
    //   console.log(element);
    //   element.classList.toggle("dark-mode");
    if (mode == 'moon') {
        document.querySelector('.fa-sun-o').style.display = 'block'
        document.querySelector('.fa-moon-o').style.display = 'none'
        let arr = document.getElementsByTagName('*')
        for (let i = 0; i < arr.length; i++) {
            arr[i].style.backgroundColor = '#16171d'
            arr[i].style.color = 'white'

        }
    } else {
        document.querySelector('.fa-sun-o').style.display = 'none'
        document.querySelector('.fa-moon-o').style.display = 'block'
        let arr = document.getElementsByTagName('*')
        for (let i = 0; i < arr.length; i++) {
            arr[i].style.backgroundColor = 'white'
            arr[i].style.color = 'black'
        }
    }
}

</script>

<style >
/* *{
    background-color: #16171d !important;
    color:#fff !important;
} */
.btn-close {
    color: red;
    /* top: 10px;
    position: fixed; */
}
</style>